import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 6,
  padding: "8px 12px",
  backgroundColor: theme.palette.primarySubtle,
  border: `1px solid ${theme.palette.primaryBorder}`,
  borderRadius: 6,
  marginTop: 8,
  fontSize: 12,
  lineHeight: 1.5,

  [theme.down("sm")]: {
    fontSize: 11,
    padding: "6px 10px",
  },
}));

export const HintIcon = styled("span")(({ theme }) => ({
  flexShrink: 0,
  fontSize: 14,
  marginTop: 1,
}));

export const HintText = styled("span")(({ theme }) => ({
  color: theme.palette.primaryDark,
  flex: 1,
}));
